import * as React from "react";
import type { NodeViewProps } from "@tiptap/react";
import { NodeViewWrapper } from "@tiptap/react";
import { ScrollText } from "lucide-react";
import { PromptMentionChip, promptMentionChipSelectedClassName } from "./PromptMentionChip";

export const SkillMentionNodeView: React.FC<NodeViewProps> = ({ node, selected }) => {
  const id = typeof node.attrs?.id === "string" ? node.attrs.id : "";
  const slug = typeof node.attrs?.slug === "string" ? node.attrs.slug : "";
  const name = typeof node.attrs?.name === "string" ? node.attrs.name : "";

  return (
    <NodeViewWrapper
      as="span"
      className="inline-block align-middle whitespace-nowrap leading-none"
      data-skill-id={id}
      data-skill-slug={slug}
      data-skill-name={name}
    >
      <PromptMentionChip
        icon={ScrollText}
        aria-selected={selected || undefined}
        className={selected ? promptMentionChipSelectedClassName : undefined}
      >
        /{slug}
      </PromptMentionChip>
    </NodeViewWrapper>
  );
};
